import classNames from "classnames";
import { useFetchProtectedArea } from "hooks/useFetch";
import { sanitizeHtml } from "lib/util";

function isTourSection(
  section:
    | Travelguide.POISection.Information
    | Travelguide.TourSection.Information
): section is Travelguide.TourSection.Information {
  return "protectedAreaId" in section;
}

export const InformationSection = ({
  section,
}: {
  section:
    | Travelguide.POISection.Information
    | Travelguide.TourSection.Information;
}) => {
  const protectedArea = useFetchProtectedArea(
    isTourSection(section) ? section.protectedAreaId : null
  );

  return (
    <section className="flex flex-col gap-5 px-4 md:px-6">
      <header>
        <h2>Informationen</h2>
      </header>
      <main
        className={classNames(
          "flex flex-col md:grid md:grid-cols-2 gap-10 gap-y-6",
          "lg:grid-cols-[repeat(auto-fit,minmax(calc(100%/3-(2.5rem*2/3)),1fr))]"
        )}
      >
        {!isTourSection(section) && section.businessHours && (
          <div className="flex flex-col gap-2">
            <h3>Öffnungszeiten</h3>
            {sanitizeHtml(section.businessHours)}
          </div>
        )}

        {!isTourSection(section) && section.pricing && (
          <div className="flex flex-col gap-2">
            <h3>Preise</h3>
            {sanitizeHtml(section.pricing)}
          </div>
        )}

        {section.properties && (
          <div className="flex flex-col gap-2">
            <h3>Weitere Besonderheiten</h3>
            <ul className="list-disc pl-5">
              {section.properties.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        )}

        {protectedArea && (
          <div className="flex flex-col gap-2">
            <h3>Schutzgebiete</h3>
            <p>
              Ihr Besuch führt Sie in folgendes Schutzgebiet:
              <br />
              <i>{protectedArea.title}</i>
            </p>
            <ul className="list-disc pl-5">
              {protectedArea.properties?.map(({ text }, i) => (
                <li key={i}>{text}</li>
              ))}
            </ul>
          </div>
        )}
      </main>
    </section>
  );
};
